
export class SaleOrderDetailsResponse {
    saleOrderId: number;
    saleOrderNumber: string;
    soProcessType?: string;
    customerPO?: string;
    soDate?: Date;
    poNumber?:string;
    factoryId?:number

    /**
     * 
     * @param saleOrderId 
     * @param saleOrderNumber 
     */
    constructor(saleOrderId: number, saleOrderNumber: string,soProcessType?:string, soDate?: Date, customerPO?: string,factoryId?:number
        ){ 
            this.saleOrderId = saleOrderId
            this.saleOrderNumber = saleOrderNumber
            this.soProcessType = soProcessType
            this.soDate = soDate;
            this.customerPO = customerPO;
            this.factoryId = factoryId
        }
    }
